import { el } from './dom.js';

let node: HTMLElement | null = null;
let timer = 0;

/**
 * One line, bottom of the screen, above the hand. Used for the "why can't I
 * play this" explanation and for server rejections — same voice either way.
 */
export function toast(message: string, tone: 'info' | 'warn' = 'info'): void {
  if (!node) {
    node = el('div', 'toast');
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    document.body.append(node);
  }
  node.textContent = message;
  node.classList.toggle('toast--warn', tone === 'warn');
  node.classList.add('toast--on');
  window.clearTimeout(timer);
  timer = window.setTimeout(() => node?.classList.remove('toast--on'), 2600);
}
